import React, { Component } from 'react'
import SostaOnlineApiService from "../../../../../services/SostaOnlineApiService";
import moment from "moment";
import ReactTable from "react-table";

const Text = (props) => <div className={props.bold ? 'text-bold-user ' + props.className : 'text-regular-user ' + props.className} {...props}>{props.children}</div>

class Participiants extends Component {
    columns = [
        {
            Header: 'ID Partecipazione',
            accessor: 'id',
            filterable: true,
            sortable: false,
            width: 80,
            Cell: (row) => {
                if (!row.value) {
                    return null
                }
                return (<div>{row.value}</div>)
            }
        },
        {
            Header: 'ID Utente',
            accessor: 'User.id',
            filterable: true,
            sortable: false,
        },
        {
            Header: 'Nome',
            accessor: 'User.firstName',
            filterable: true,
            sortable: false,
        },
        {
            Header: 'Cognome',
            accessor: 'User.lastName',
            filterable: true,
            sortable: false,
        },
        {
            Header: 'Codice Fiscale',
            accessor: 'User.fiscalCode',
            filterable: true,
            sortable: false,
        },
        {
            Header: 'Data Partecipazione',
            accessor: 'createdAt',
            filterable: false,
            sortable: false,
            Cell: (row) => {
                if (!row.value) {
                    return null
                }
                return (<div>{moment(row.value).format('L LT')}</div>)
            }
        },
        {
            Header: 'Stato',
            accessor: 'status',
            filterable: false,
            sortable: false,
            Cell: (row) => {
                if (!row.value) {
                    return null
                }
                return (<div>{row.value}</div>)
            }
        },
        {
            Header: 'Azioni',
            accessor: '',
            filterable: false,
            sortable: false,
            Cell: (row) => {
                return (
                  <a
                    onClick={() => this.rejectUser(row.original.id)}
                    className="btn btn-danger"
                  >
                      Escludi Utente
                  </a>
                )
            }
        }
    ]

    constructor (props) {
        super(props)

        this.state = {
            subscriptions: [],
            pagination: {
                total: 0,
                limit: 100,
                offset: 0
            },
            filters: {}
        }
    }

    componentDidMount () {
        this.setState({loading: true})
        this.fetchSubscriptions()
    }

    onCreateWaitingListClick = () => {
        this.props.history.push('/backoffice/waiting-lists/create')
    }

    fetchSubscriptions = (filterObj, limit, offset) => {
        const { match } = this.props
        const { params } = match
        const { id } = params
        this.setState({loading: true})
        let string = ''
        for (let key in filterObj) {
            string = string + key + '=' + filterObj[key] + '&'
        }

        string = string + 'waitingListId=' + id
        SostaOnlineApiService.fetchWaitingListSubscriptions(string, limit || 100, offset || 0).then((data) => {
            this.setState({
                subscriptions: data.data,
                pagination: data.pagination,
                loading: false
            })
        })
    }

    onFetchData = (state, instance) => {
        let filterObj = {}
        for (let i in state.filtered) {
            let f = state.filtered[i]
            if (typeof f.value === 'string') {
                filterObj[f.id] = f.value
            }
            if (f.id === 'User.id') {
                delete filterObj[f.id]
                filterObj['userId'] = f.value
            }
            if (f.id === 'User.firstName') {
                delete filterObj[f.id]
                filterObj['firstName'] = f.value
            }
            if (f.id === 'User.lastName') {
                delete filterObj[f.id]
                filterObj['lastName'] = f.value
            }
            if (f.id === 'User.fiscalCode') {
                delete filterObj[f.id]
                filterObj['fiscalCode'] = f.value
            }
        }

        let sortObj = {}
        for (let i in state.sorted) {
            let s = state.sorted[i]
            sortObj[s.id] = s.desc ? 'desc' : 'asc'
        }

        this.fetchSubscriptions(filterObj, state.pageSize, state.page)
    }

    handleFilterChange = (filter) => {
        let newFilters = Object.assign({}, this.state.filters)
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter
        } else {
            delete newFilters[filter.column.key]
        }
        this.setState({ filters: newFilters })
    }

    onClearFilters = () => {
        // all filters removed
        this.setState({filters: {} })
    }

    getTotalPages = () => {
        const {pagination} = this.state

        if (!pagination) {
            return 0
        }

        if (pagination.total === 0) {
            return 0
        }

        return Math.ceil(pagination.total / pagination.limit)
    }

    rejectUser = async (waitingListSubscriptionId) => {
        try {
            const result = await SostaOnlineApiService.rejectUserFromWaitingList(waitingListSubscriptionId)
            await this.fetchSubscriptions()
        } catch (e) {
            // alert('Si è verificato un errore durante l\'eliminazione dell')
            console.log(e)
        }
    }

    render () {
        return (
          <div>
              <ReactTable
                manual
                filterable
                loading={this.props.loading}
                noDataText="Nessuna Lista d'Attesa Presente"
                onFetchData={this.onFetchData}
                pages={this.getTotalPages()}
                className="-highlight"
                data={this.state.subscriptions ? this.state.subscriptions : []}
                style={{maxHeight: '500px'}}
                defaultPageSize={100}
                nextText="Avanti"
                previousText="Indietro"
                loadingText="Caricamento in corso..."
                rowsText="elementi"
                ofText="di"
                pageText="Pagina"
                columns={this.columns}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {
                            if (!rowInfo) {
                                return
                            }
                            console.log(rowInfo)
                            this.props.history.push('/backoffice/users/' + rowInfo.original.userId)
                        }
                    }
                }}
              />
          </div>
        )
    }
}

export default Participiants



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/Details/Participiants/Participiants.js